import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { ParcelOrderDialog } from 'src/modules/supply_chain/components/parcel/OrderDialog'
import { skuit } from 'src/services/skuit'

import { ParcelOrderListTable } from 'src/components/Table/list/ParcelOrder'
import { ListPage } from 'src/components/Pages/ListPage'

export const OrderListPage = () => {
  const paginator = useQueryPaginator('parcel-order-list', skuit.sc.parcel.orders.list)

  return (
    <ListPage
      title='Parcel Orders'
      paginator={paginator}
      dialogs={[{ title: 'New Parcel Order', Dialog: ParcelOrderDialog }]}
    >
      <ParcelOrderListTable
        paginator={paginator}
        fields={['number', 'client', 'placedOn', 'fulfillOn', 'consignee', 'status', 'flags', 'customFields']}
        bulkActions={['printOrder', 'printPickTicket', 'printAll', 'divider', 'status', 'cancel']}
      />
    </ListPage>
  )
}
